// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Iekk","content":"styles_content__2xOMR","selectAll":"styles_selectAll__mXAM4"};